import { PageTemplate } from "@/common/PageWrapper";

export function MaterialVideo2() {
    return (
        <PageTemplate>

            <div className="min-h-screen flex flex-col">
                <main className="flex-1">
                    <div className="w-full h-max px-4 py-5 bg-white inline-flex justify-center items-start gap-2.5 overflow-hidden">
                        <div className="flex-1 self-stretch p-2.5 inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden">
                            <div className="self-stretch rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-100 flex flex-col justify-center items-start">
                                <div className="self-stretch px-7 py-6 inline-flex justify-between items-center">
                                    <div className="w-full justify-start text-zinc-800 text-2xl font-semibold font-['Be_Vietnam_Pro'] leading-9">Elements of Digital Marketing Pt. 2</div>
                                </div>
                                <div className="self-stretch px-7 py-6 rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-100 inline-flex justify-start items-center gap-1.5">
                                    <div className="relative w-full" style={{ aspectRatio: '16 / 9' }}>
                                        <iframe
                                        src="https://iframe.mediadelivery.net/embed/482568/170a8f81-0c25-4211-a6ec-10bdbd07a5db?autoplay=true&loop=false&muted=false&preload=true&responsive=true"
                                        loading="lazy"
                                        className="absolute inset-0 h-full w-full"
                                        style={{ border: 0 }}
                                        allow="accelerometer; gyroscope; encrypted-media; picture-in-picture"
                                        allowFullScreen
                                        title="Intro video 1"
                                        />
                                    </div>
                                </div>
                            </div>
                            <a href="/#/course1/" className="self-stretch h-12 px-3.5 py-3 bg-teal-900 rounded-md inline-flex justify-center items-center gap-1">
                                <div className="justify-start text-white text-lg font-bold font-['Be_Vietnam_Pro']">Selesai</div>
                            </a>
                        </div>
                    </div>
                </main>
                <footer className="relative text-center flex justify-center items-start pt-6 pb-[120px]">
                <p className="w-full max-w-5xl md:max-w-6xl mx-auto px-4 md:px-6 text-gray-600 text-sm md:text-base font-medium">
                    This applied research initiative is conducted by lecturers and students of Universitas Multimedia Nusantara, supported and funded through the 2025 Dikti Grant Scheme in collaboration with Kehati partners.
                </p>
                <div
                    className="pointer-events-none absolute inset-x-0 bottom-0 h-[120px] bg-bottom bg-repeat-x"
                    style={{
                        backgroundImage: `url(${new URL('~/src/assets/pattern.png', import.meta.url).href})`,
                        backgroundSize: 'auto',
                    }}
                />
            </footer>
            </div>
        </PageTemplate>
    );
}